import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private afAuth: AngularFireAuth) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe<HttpEvent<any>>(
      catchError<HttpEvent<any>, Observable<HttpEvent<any>>>((err: any) => {
        if (err.status === 403) {
          this.afAuth.signOut();
          location.reload();
        }

        const error = err?.error?.message || err.statusText;
        return throwError(() => new Error(error));
      })
    );
  }
}
